import { Component, OnInit, AfterViewInit } from '@angular/core';
import { AuthService } from 'src/app/shared/route-guards/services/auth.service';
import { ScriptLoaderService } from 'src/app/script-loader.service';
declare var $;
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit , AfterViewInit {
  constructor(public authService: AuthService, private loaderService: ScriptLoaderService) { }

  ngOnInit() {
  }
  ngAfterViewInit() {
    this.loaderService.loadScripts('body', [
      'assets/libs/perfect-scrollbar/dist/perfect-scrollbar.jquery.min.js',
    ]);
  }
}
